<p>equipement-create works!</p>
